import { Message } from "aderant-conflicts-models";

export const Messages = {
    DISPLAY_DATA: new Message("DISPLAY_DATA", "Display Secured Data"),
    DISPLAY_DATA_SUBHEADING_1: new Message("DISPLAY_DATA_SUBHEADING_1", "Choose which fields in the Results grid will be visible when viewing secured entities."),
    DISPLAY_DATA_SUBHEADING_2: new Message("DISPLAY_DATA_SUBHEADING_2", "If a field is selected, the corresponding data will be visible. If a field is not selected, its data will be obfuscated."),
    SAVE_COMPLETE_SNACKBAR_SUCCESS: new Message("SAVE_COMPLETE_SNACKBAR_SUCCESS", "List of secured fields updated successfully."),
    SAVE_COMPLETE_SNACKBAR_FAILURE: new Message("SAVE_COMPLETE_SNACKBAR_FAILURE", "List of secured fields failed to update. Please try again.")
};
